import Header from "./header";
import Sidebar from "./sidebar";
import { useLocation } from 'react-router-dom';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const location = useLocation();

  // Array of paths where sidebar should be shown
  const chatPaths = ['/sales', '/doctor'];

  // Check if current path is a chat page
  const isChatPage = chatPaths.includes(location.pathname);

  return (
    <div>
      <main style={{ display: 'flex' }}>
        {isChatPage && <Header />}
        {isChatPage && <Sidebar />}
        <div style={{ flexGrow: 1 }}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default AppLayout;